export default `
	guid
	created_at
	updated_at
	name
	description
	booking_dates
	active
`;
